import React, { Component } from 'react';
import { Redirect } from 'react-router';
import ValidateTool from '../modules/tools/ValidateTool';
import { Dialog, DialogTitle, Button, DialogContent, DialogActions } from '@material-ui/core';
import GenericTools from '../modules/tools/GenericTools'
import Auth from '../modules/auth/Auth';
import ElementsHandler from '../handlers/ElementsHandler';
import '../css/Login.scss'

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            redirTo: false,
            isValid: false,
            loginMsg: ''
        }
        this.elementsHandler = new ElementsHandler(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    async handleLogin(e) {
        e.preventDefault();

        let email = this.refs.email.value;
        let pw = this.refs.pw.value;

        this.setState({ isLoading: true });

        let res = await Auth.login(email, pw);
        // console.log("Auth.authenticate res", res);

        this.setState({ isLoading: false });

        if (!res.success) {
            console.log("login failed with error", res.msg);
            this.setState({ loginMsg: res.msg.error.msg });
            return;
        }
        //if res.success is true
        let pwdResetRequired = res.user && res.user.pwdResetRequired;
        // console.log(this.props.redirectUrl, 'this.props.redirectUrl')
        let redirTo = this.props.redirectUrl || "/";
        if (pwdResetRequired) redirTo = "/new-password";
        GenericTools.safe_redirect(redirTo);
    }


    render() {
        if (this.state.redirTo != false) return (<Redirect to={{ pathname: '/', state: this.state }} />);

        return (
            <>
                <div className='blue-bg App loginPage'>
                    <div onClick={() => this.props.history.push("/")} id="first-go-to-login">הרשמת מתנדב</div>
                    <div className="yellowSticker">מאגר המתנדבים של המדינה!</div>
                    <form className="loginForm" onSubmit={this.handleLogin} id="logForm">
                        <div id="formTitle">כניסת משתמשים</div>
                        <input className="loginInput" type='email' ref='email' placeholder='מייל' required />
                        <input className="loginInput" type='password' ref='pw' placeholder='סיסמא' required />
                        {this.state.loginMsg !== '' && <div className='msg-error'>{this.state.loginMsg}</div>}
                        {this.state.isLoading ?
                            <button className="loginButton">מתחבר...</button> :
                            <button className="loginButton" onClick={this.handleLogin} type='button'>היכנס</button>
                        }
                    </form>
                </div>
            </>
        )
    }
}

window.ValidateTool = ValidateTool;
export default Login;